import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLoyaltyBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 68,
    viewBox: "0 0 57 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.986 22a8.483 8.483 0 00-7.844 5.247 8.51 8.51 0 001.84 9.263 8.488 8.488 0 009.253 1.843 8.507 8.507 0 002.754-13.863A8.485 8.485 0 0025.986 22zm0 12.112a3.606 3.606 0 01-3.334-2.23 3.617 3.617 0 01.783-3.936 3.607 3.607 0 016.16 2.554 3.616 3.616 0 01-2.228 3.337 3.604 3.604 0 01-1.381.275z",
    fill: "url(#loyalty-banner_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M44.463 64c0 1.658-1.342 3-2.995 3a2.998 2.998 0 01-2.995-3c0-1.658 1.342-3 2.995-3a2.998 2.998 0 012.995 3z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.46 18.781l3.607.17L54.104 17l-.17 3.61 1.95 3.041-3.605-.17-3.038 1.953.17-3.61-1.95-3.042z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 16.348l1.948-1.774L2.51 12l1.772 1.948 2.573.56-1.948 1.774-.562 2.574-1.772-1.948L0 16.348z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.672 58.441l4.012-3.333 1.343-5.043 3.33 4.017 5.037 1.344-4.012 3.333-1.343 5.044-3.33-4.017-5.037-1.345zM50.98 55.592l1.985-1.026 1.024-1.987 1.025 1.987 1.985 1.026-1.985 1.026-1.025 1.986-1.024-1.986-1.985-1.026z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.478,
    cy: 10,
    rx: 1.998,
    ry: 2,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 11.503,
    cy: 1,
    rx: 0.999,
    ry: 1,
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 34.975,
    cy: 47.5,
    rx: 1.498,
    ry: 1.5,
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 2.513,
    cy: 42,
    rx: 1.998,
    ry: 2,
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loyalty-banner_svg__paint0_linear",
    x1: 20.503,
    y1: 22,
    x2: 30.436,
    y2: 25.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}

export { SvgLoyaltyBanner as ReactComponent };
